export enum ProductKey {
	JIRA_SOFTWARE = 'jira-software.ondemand',
	CONFLUENCE = 'confluence.ondemand',
	JIRA_SERVICE_MANAGEMENT = 'jira-servicedesk.ondemand',
	JIRA_PRODUCT_DISCOVERY = 'jira-product-discovery',
}

export const products = [
	{
		bundle: 'jira-software',
		description: 'Jira',
		key: ProductKey.JIRA_SOFTWARE,
		name: 'jira',
	},
	{
		bundle: 'confluence',
		description: 'Confluence',
		key: ProductKey.CONFLUENCE,
		name: 'confluence',
	},
	{
		bundle: 'jira-service-management',
		description: 'Jira Service Management',
		key: ProductKey.JIRA_SERVICE_MANAGEMENT,
		name: 'jira-servicedesk',
	},
	{
		bundle: 'jira-product-discovery',
		description: 'Jira Product Discovery',
		key: ProductKey.JIRA_PRODUCT_DISCOVERY,
		name: 'jira-product-discovery',
	},
] as const;

export type Product = (typeof products)[number];

export type Edition = 'free' | 'standard' | 'premium';
